"use strict";
/* eslint-disable react/display-name */
// * You should NOT edit this file directly. Read CONTRIBUTING.md for more information on creating icons
Object.defineProperty(exports, "__esModule", { value: true });
exports.XIcon16Solid = void 0;
var tslib_1 = require("tslib");
var react_1 = tslib_1.__importDefault(require("react"));
var forwardRef_1 = require("../../helpers/forwardRef");
var BaseIcon_1 = require("../../internal/BaseIcon");
exports.XIcon16Solid = forwardRef_1.forwardRef('XIcon16Solid', function (props, ref) {
    return (react_1.default.createElement(BaseIcon_1.BaseIcon, tslib_1.__assign({ ref: ref, viewBoxSize: 16 }, props),
        react_1.default.createElement("path", { d: "M2.94 2.94a1.5 1.5 0 0 1 2.12 0L8 5.878l2.94-2.94a1.5 1.5 0 1 1 2.12 2.122L10.122 8l2.94 2.94a1.5 1.5 0 1 1-2.122 2.12L8 10.122l-2.94 2.94a1.5 1.5 0 1 1-2.12-2.122L5.878 8l-2.94-2.94a1.5 1.5 0 0 1 0-2.12Z" })));
});
